import React, { useContext } from 'react';
import { RelationManyValueContainerProps } from './relationManyValueProps';
import { ReportingContainerBaseConfig } from '../../../../base';
import {
    RelationManyValueController,
    RelationManyValueLoader,
} from './relationManyValueInterface';

export function createRelationManyValueContainer(
    config: ReportingContainerBaseConfig,
    loader: RelationManyValueLoader,
    controller: RelationManyValueController
): React.FC<RelationManyValueContainerProps> {
    const {
        context: { useContext },
    } = config;

    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, containerProps);
        const props = controller.useProps(context, data, {});
        return <View {...props} />;
    };
}
